export const filterWidth = '200px';

export const deltaDescriptionTooltip = `
	Equal - non-digital parameters which values were not changed.\n
	Other - parameters whose values have been changed but cannot be compared.
	N/A - parameters that are missed in one of the configurations.
`;
